import { httpClient } from '@/services/http/httpClient'

type User = {
  id: string
  name: string
  email: string
  image: string
  area: {
    id: string
    name: string
  }
  type: string
}

export type GetUsersProjectParams = {
  projectId: string
  search: string
}

export async function getUsersProjectInvite({
  projectId,
  search,
}: GetUsersProjectParams) {
  const { data } = await httpClient.get<User[]>(
    `/projects/project-invites/${projectId}/users?search=${search}`,
  )

  return data
}
